import {Component} from '@angular/core';

@Component({
    selector: 'app-trend-list',
    templateUrl: './trend-list.component.html',
    styleUrls: ['./trend-list.component.css'],
    standalone: false
})
export class TrendListComponent
{
}
